import React from 'react'
import Select from 'react-select'
import axios from 'axios'
import {getToken} from '../../../storage'
import {API_BASE_URL} from '../../../constants'
import {AddItemModal} from '../../modal/modal'
import {ItemExtended} from '../../commons/functions'



export default class NameElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.createItemPromt = this.createItemPromt.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.state= {showItemCreate:false}
    this.handleItemModal = this.handleItemModal.bind(this)
  }

  handleItemModal() {
    this.setState({
      showItemCreate:false
    })
  }

  createItemPromt(input){
    return "Create new item ?"
  }

  handleChange(item){

    if(item !== null && typeof item.className !== "undefined" ) {
        this.setState({
          showItemCreate:true
        })
    }
    else if(item !== null) {

      const i = {
        serial:item.serial,
        item:item.id,
        name: item.name,
        hsn: item.hsn,
        quantity:1,
        tableIndex: this.props.item.tableIndex,
        mrp: parseFloat(item.mrp),
        discount_set: item.discount_set,
        selling_basic_rate: parseFloat(item.selling_basic_rate),
        purchase_basic_rate: parseFloat(item.purchase_basic_rate),
        selling_rate: parseFloat(item.selling_rate),
        price: parseFloat(item.selling_basic_rate),
        gst: item.gst,
        cgst_amount: parseFloat(item.cgst_amount), sgst_amount: parseFloat(item.sgst_amount), igst_amount: parseFloat(item.igst_amount),
        total: parseFloat(item.selling_rate),
        discount_value: 0
       }
       this.props.onAddCallback(i)
       this.setState({showItemCreate:false})
    }
    else {

      const i = {
        serial:"",
        name: "",
        hsn: "",
        quantity:1,
        tableIndex: this.props.item.tableIndex,
        mrp:0,
        gst:{},
        discount_set: [],
        selling_basic_rate: 0,
        purchase_basic_rate: 0,
        selling_rate:0,
        discount_value:0,
        price: 0,
        tax: 0,
        cgst_amount: 0, sgst_amount: 0, igst_amount: 0,
        total: 0
       }
       this.props.onAddCallback(i)
       this.setState({showItemCreate:false})
    }


  }

  getItems (input) {
    if (!input) {
      return Promise.resolve({ options: [] });
    }
    return   axios({
        url: '/list_items/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.items}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
}
renderOption(option) {
  return <ItemExtended option={option} />
}

  render() {

    let modal
    if(this.state.showItemCreate) {
      modal = <AddItemModal show={this.state.showItemCreate} handleModalToggle={this.handleItemModal} onAddCallback={this.handleChange} />
    }

    let inputValue = this.props.item


    return (<div>
        {modal}
    <Select.AsyncCreatable name="name" className="" value={inputValue}
      promptTextCreator={this.createItemPromt} optionRenderer={this.renderOption}
      valueKey="id" labelKey="name" loadOptions={this.getItems} onChange={this.handleChange} />
    </div>)


  }
}
//
//
// const mapStateToProps = (state) => {
//   return {
//     retn: state.retnReducer,
//     itemRed: state.itemReducer
//   }
// }
//
// export default connect(mapStateToProps)(NameElement)



// WEBPACK FOOTER //
// ./src/components/credit/rowelements/nameelement.js